import { translations } from "../translations/translations-manager";

export function formatAmount(amount: number): string {
  return amount.toLocaleString(translations.getLanguage(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
}